<template>
  <!--  blue logo -->
  <img
    src="https://summitproedu.imgix.net/summit-education-logo.svg"
    alt="Summit Professional Education"
  />
</template>

<style scoped>
img {
  width: 115px;
}
</style>
